<template>
    <div class="sw-modal edit-task">
        <div v-click-outside="cancel" class="sw-modal-content" v-on:click.stop>
            <div class="row sw-modal-heading">
                <div class="col text-center">
                    <h4>
                        <i class="fas fa-bed"></i>
                        <span v-if="editingBooking">Edit Booking</span>
                        <span v-else>Add a Booking</span>
                    </h4>
                </div>
            </div>
            <div class="sw-modal-body" v-if="booking">
                <ValidationObserver ref="taskForm">
                    <form v-on:submit.prevent="saveBooking()" >
                        <ul>
                            <!-- BOOKER -->
                            <li class="row">
                                <div class="divider-container col-12">
                                    <div class="divider-line divider-line--left"></div>
                                    <i class="fas fa-user"></i>
                                    <span>Booked by</span>
                                    <div class="divider-line divider-line--right"></div>
                                </div>
                            </li>
                            <li class="row question">
                                <label for="guest-first-name" class="col-12 question__question">Name</label>
                                <div class="col-12">
                                    <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                        <div class="row edit-booking__name">
                                            <div class="col-6">
                                                <input ref="firstNameInput" type="text" v-model="booking.bookedBy.firstName" id="guest-first-name" placeholder="First name" class="short-question">
                                            </div>
                                            <div class="col-6">
                                                <input type="text" v-model="booking.bookedBy.lastName" placeholder="Last name" class="short-question">
                                            </div>
                                        </div>
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>
                            <li class="row question">
                                <label for="guest-email-address" class="col-12">Email address</label>
                                <div class="col-12">
                                    <ValidationProvider rules="required|email" v-slot="{ errors }">
<!--                                        <input v-model="booking.bookedBy.email" id="guest-email-address" type="text" class="form-account__text short-question" placeholder="Email address">-->
                                        <input v-model="booking.bookedBy.email" id="guest-email-address" type="text" class="form-account__text short-question">
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>
                            <li class="row question">
                                <label for="guest-mobile" class="col-12">Mobile</label>
                                <div class="col-12">
                                    <vue-tel-input id="guest-mobile"
                                                   v-model="booking.bookedBy.mobile"
                                                   v-bind:mode="'international'"
                                                   v-bind:enabledCountryCode="true"
                                                   v-bind:preferredCountries="['ZA']"
                                                   v-bind:autoFormat="true"
                                                   v-bind:defaultCountry="'ZA'"
                                                   v-on:open="onTelephoneDropdownToggle(true)"
                                                   v-on:close="onTelephoneDropdownToggle(false)">
                                        <template v-slot:arrow-icon>
                                            <span>{{ isTelephoneDropdownOpen ? '▲' : '▼' }}</span>
                                        </template>
                                    </vue-tel-input>
                                </div>
                            </li>
                            <li v-if="providerChannels.length > 0" class="row question section-end">
                                <label for="channel" class="col-12">Channel</label>
                                <div class="col-12">
                                    <select v-model="booking.channel.providerChannelId" id="channel">
                                        <option value="unknown">Unknown</option>
                                        <option v-for="(channel, index) in providerChannels" v-bind:key="index" v-bind:value="channel.providerChannelId">{{channel.providerChannelName}}</option>
                                    </select>
                                </div>
                            </li>

                            <!-- DATES -->
                            <li class="row">
                                <div class="divider-container col-12">
                                    <div class="divider-line divider-line--left"></div>
                                    <i class="fas fa-calendar-alt"></i>
                                    <span>Check-In &amp; Out</span>
                                    <div class="divider-line divider-line--right"></div>
                                </div>
                            </li>
                            <li class="row question section-end">
<!--                                <label for="checkInOut" class="col-3">Check in & out</label>-->
                                <div class="col-12 input-group edit-task__date">
                                    <ValidationProvider rules="validateCheckInOut" v-slot="{ errors }">
                                        <flat-pickr v-model="checkInOut" v-bind:config="flatPickrConfig" id="checkInOut" v-bind:class="checkInOut" v-on:on-open="openedFlatPkr()" v-on:on-close="closedFlatPkr()"></flat-pickr>
                                        <a title="Select date" data-toggle>
                                            <i class="fas fa-calendar-alt"></i>
                                        </a>
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>

                            <!-- ROOMS -->
                            <li v-for="(room, index) in booking.rooms" v-bind:key="index">
                                <ul>
                                    <li class="row">
                                        <div class="divider-container col-12">
                                            <div class="divider-line divider-line--left"></div>
                                            <i class="fas fa-house-user"></i>
                                            <span>Property {{index+1}}</span>
                                            <div class="divider-line divider-line--right"></div>
                                            <div v-if="index > 0" v-on:click="removeProperty(index)" class="edit-booking__remove-room">
                                                -
                                            </div>
                                        </div>
                                    </li>
                                    <li class="row question">
                                        <label for="room-type" class="col-12 capitalize">{{getUnitTypeForDisplay}}</label>
                                        <div class="col-12">
                                            <ValidationProvider rules="required|min:3" v-slot="{ errors }">
                                                <input v-model="room.roomTypeName" id="room-type" type="text" class="form-account__text short-question">
                                                <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </li>
                                    <li class="row question">
                                        <label for="adults" class="col-6">Adults</label>
                                        <label for="children" class="col-6">Children</label>
                                        <div class="col-6">
                                            <select v-model="room.numberOfAdults" id="adults">
                                                <option value="0">0</option>
                                                <option v-for="index in 30" v-bind:key="index" v-bind:value="index">{{index}}</option>
                                            </select>
                                        </div>
                                        <div class="col-6">
                                            <select v-model="room.numberOfChildren1" id="children">
                                                <option value="0">0</option>
                                                <option v-for="index in 30" v-bind:key="index" v-bind:value="index">{{index}}</option>
                                            </select>
                                        </div>
                                    </li>
<!--                                    <li class="row question">-->
<!--                                        <label for="adults" class="col-12">Adults</label>-->
<!--                                        <div class="col-12">-->
<!--                                            <select v-model="room.numberOfAdults" id="adults">-->
<!--                                                <option value="0">0</option>-->
<!--                                                <option v-for="index in 30" v-bind:key="index" v-bind:value="index">{{index}}</option>-->
<!--                                            </select>-->
<!--                                        </div>-->
<!--                                    </li>-->
<!--                                    <li class="row question">-->
<!--                                        <label for="children" class="col-12">Children</label>-->
<!--                                        <div class="col-12">-->
<!--                                            <select v-model="room.numberOfChildren1" id="children">-->
<!--                                                <option value="0">0</option>-->
<!--                                                <option v-for="index in 30" v-bind:key="index" v-bind:value="index">{{index}}</option>-->
<!--                                            </select>-->
<!--                                        </div>-->
<!--                                    </li>-->
                                    <li class="row question section-end">
                                        <label for="room-rate" class="col-6 edit-booking__amount-label">Total (all nights)</label>
                                        <div class="col-6">
                                            <ValidationProvider rules="required|double:2" v-slot="{ errors }">
                                                <div style="display: flex; align-items: center">
                                                    {{getEstablishment.rules.currencyCode}}
                                                    <input v-model="room.roomRateTotal" id="room-rate" type="text" class="form-account__text form-account__text--currency short-question">
                                                </div>
                                                <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </div>
                                    </li>
<!--                                    <li class="row">-->
<!--                                        <label for="room-rate" class="col-12"><span class="capitalize">{{getUnitTypeForDisplay}}</span> daily rate (average per night)</label>-->
<!--                                        <div class="col-12">-->
<!--                                            <ValidationProvider rules="required|numeric" v-slot="{ errors }">-->
<!--                                                <div style="display: flex; align-items: center">-->
<!--                                                    {{getEstablishment.rules.currencyCode}}-->
<!--                                                    <input v-model="room.roomRate" id="room-rate" type="text" class="form-account__text form-account__text&#45;&#45;currency">-->
<!--                                                </div>-->
<!--                                                <span class="form__error" v-if="errors">{{ errors[0] }}</span>-->
<!--                                            </ValidationProvider>-->
<!--                                        </div>-->
<!--                                    </li>-->

<!--                                    <li v-if="index > 0">-->
<!--                                        <button v-on:click="removeProperty(index)" class="btn btn-secondary">Remove</button>-->
<!--                                    </li>-->
                                </ul>
                            </li>
                            <li class="row section-end">
                                <div class="edit-booking__add-room col-12">
                                    <a v-on:click="addProperty" class="">+</a>
                                </div>
                            </li>

                            <!-- AMOUNTS -->
                            <li>
                                <div class="divider-container col-12">
                                    <div class="divider-line divider-line--left"></div>
                                    <i class="fas fa-coins"></i>
                                    <span>Amounts</span>
                                    <div class="divider-line divider-line--right"></div>
                                </div>
                            </li>
                            <li class="row question">
                                <label for="total" class="col-6 edit-booking__amount-label">Total <span class="text-note">(calculated)</span></label>
                                <div class="col-6">
                                    <div style="display: flex; align-items: center">
                                        {{getEstablishment.rules.currencyCode}}
                                        <input v-model="getTotal" id="total" type="text" class="form-account__text form-account__text--currency short-question" disabled>
                                    </div>
                                </div>
                            </li>
                            <li class="row question">
                                <label for="deposit" class="col-6 edit-booking__amount-label">Booking deposit</label>
                                <div class="col-6">
                                    <ValidationProvider rules="required|double:2" v-slot="{ errors }">
                                        <div style="display: flex; align-items: center">
                                            {{getEstablishment.rules.currencyCode}}
                                            <input v-model="booking.deposit" id="deposit" type="text" class="form-account__text form-account__text--currency short-question">
                                        </div>
                                        <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                                    </ValidationProvider>
                                </div>
                            </li>
                        </ul>

                        <div v-show="waiting">
                            <Spinner/>
                        </div>  

                        <div v-show="!waiting" class="col-12">
                            <div v-if="error">
                                <div class="col-12 alert alert-danger" role="alert">
                                    {{error}}
                                </div>
                                <button v-on:click.prevent="cancel" class="btn btn-secondary">Close</button>
                            </div>
                            <div v-else-if="success">
                                <div class="col-12 alert alert-success" role="alert">
                                    {{success}}
                                </div>
                                <button v-on:click.prevent="$root.$emit('finished-editing-booking')" class="btn btn-secondary">Done</button>
                            </div>
                            <div v-else class="row">
                                <div class="col-6">
                                    <button v-on:click.prevent="cancel" class="btn btn-secondary">Cancel</button>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary">
                                        <template v-if="editingBooking">Save</template>
                                        <template v-else>Add</template>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import Spinner from '../Spinner.vue'

    import { store, getters } from '../../store.js'
    import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'

    import * as dayjs from 'dayjs'
    import FlatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import 'flatpickr/dist/themes/material_blue.css';

    const VueTelInput = () =>
        Promise.all([
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css')
        ]).then(([{VueTelInput}]) => VueTelInput)

    extend('validateCheckInOut', {
        validate: value => {
            console.log('validating check in & out: ' + value)
            let dates = null
            if (Array.isArray(value)) {
                dates = [dayjs(value[0]).format("YYYY-MM-DD"), dayjs(value[1]).format("YYYY-MM-DD")]
            } else {
                dates = value.split(" to ")
            }
            console.log('dates[0]: ' + dates[0])
            console.log('dates[1]: ' + dates[1])
            if (dates.length === 1) {
                return false
            }
            if (dates[0] === dates[1]) {
                return false
            }

            return true
        },
        message: 'Check out must be after check in'
    })

    export default {
        name: 'EditBooking',
        components: { Spinner, ValidationObserver, ValidationProvider, FlatPickr, VueTelInput },
        props: {
            booking: Object
        },
        data: function() {
          return {
              copy: {},
              flatPickrConfig: {
                mode: "range",
                altInput: true,
                altFormat: "M j",
                dateFormat: "Y-m-d",
                minDate: dayjs().startOf("day").toDate(),
                wrap: true,
              },
              isTelephoneDropdownOpen: false,
              providerChannels: [],
              checkInOut: [dayjs(this.booking.arrival).toDate(), dayjs(this.booking.departure).add(2, "day").toDate()],
              channel: {
                  providerChannelId: "unknown"
              },
              guest: {
                  name: '',
                  email: ''
              },
              rooms: [],
              editingDates: false,
              waiting: false,
              error: null,
              success: null
          }
        },
        computed: {
            editingBooking: function() {
                if (this.booking && typeof this.booking.reference !== 'undefined') {
                    return true;
                }
                return false;
            },
            getEstablishment: function() {
                return getters.getCurrentEstablishment();
            },
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            },
            getTotal: function() {
                let total = 0;
                for (let room of this.booking.rooms) {
                    if (room.roomRateTotal) {
                        total += parseInt(room.roomRateTotal);
                    }
                }
                return total.toFixed(2);
            }
        },
        methods: {
            onTelephoneDropdownToggle: function (open) {
                console.log("onTelephoneDropdownToggle");
                this.isTelephoneDropdownOpen = open
            },
            getDatesArray: function() {
                // this is confusing, but is here because for vue-flatpickr-component to work with a date range,
                // checkInOut needs to start as an Array, but when dates are set using the flatpickr, the value
                // is changed to a String
                let dates = null
                if (Array.isArray(this.checkInOut)) {
                    console.debug("Getting dates array from array")
                    dates =  [dayjs(this.checkInOut[0]).format("YYYY-MM-DD"), dayjs(this.checkInOut[1]).format("YYYY-MM-DD")]
                } else {
                    console.debug("Getting dates array from string")
                    dates = this.checkInOut.split(" to ")
                }
                return dates
            },
            openedFlatPkr: function() {
                this.editingDates = true;
            },
            closedFlatPkr: function() {
                this.editingDates = false;
            },
            getNumberOfNights: function(dates) {
                return dayjs(dates[1]).diff(dayjs(dates[0]), 'day');
            },
            addProperty: function() {
                console.log("Add property");
                this.booking.rooms.push({
                    name: "Standard",
                    numberOfAdults: 2,
                    numberOfChildren1: 0,
                    roomRate: ""
                });
            },
            removeProperty: function(index) {
                console.log("Removing property at index: " + index);
                this.booking.rooms.splice(index, 1);
            },
            cancel: function() {
                if (!this.editingDates) {
                    console.log("cancel");
                    if (typeof this.copy.reference !== 'undefined') {
                        // we need to reset the values to what they were before
                        this.booking.arrival = this.copy.arrival;
                        this.booking.departure = this.copy.departure;
                        this.booking.bookedBy.firstName = this.copy.bookedBy.firstName;
                        this.booking.bookedBy.lastName = this.copy.bookedBy.lastName;
                        this.booking.bookedBy.email = this.copy.bookedBy.email;
                        this.booking.rooms = JSON.parse(JSON.stringify(this.copy.rooms));
                    }
                    this.$root.$emit('finished-editing-booking');
                }
            },
            saveBooking: function () {
                console.log(this.checkInOut)
                this.$refs.taskForm.validate().then(success => {
                    console.log("Validated:" + this.checkInOut + " . Success: " + success);
                    if (!success) {
                        return
                    }

                    console.log("saving booking");
                    this.waiting = true;
                    this.error = null;

                    const numberOfNights = this.getNumberOfNights(this.getDatesArray());
                    for (let room of this.booking.rooms) {
                        room.roomName = room.roomTypeName;
                        room.roomRate = Math.round(room.roomRateTotal * 100 / numberOfNights) / 100;
                        console.log("Total: " + room.roomRateTotal + " avg: " + room.roomRate);
                    }

                    const dates = this.getDatesArray();
                    const body = {
                        dateBooked: this.booking.dateBooked,
                        arrival: "" + dates[0],
                        departure: "" + dates[1],
                        channel: { providerChannelId: (this.booking.channel) ? this.booking.channel.providerChannelId : null},
                        bookedBy: this.booking.bookedBy,
                        billedTo: this.booking.bookedBy,
                        rooms: this.booking.rooms.slice(),
                        deposit: this.booking.deposit
                    };

                    let url = '/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/bookings';

                    if (typeof this.booking.reference === 'undefined') {
                        this.$http.post(url, body
                        ).then(response => {
                            console.log("Booking added. Response: " + response);
                            this.waiting = false;
                            this.success = "Booking added";
                            this.$root.$emit('booking-added', response.data);
                            setTimeout(() => {
                                const element =  this.$el;
                                element.scrollTop = element.scrollHeight;
                            }, 100)
                        }).catch(error => {
                            this.waiting = false
                            if (error.response) {
                                this.error = "Error: " + error.response.data.message
                            } else {
                                this.error = "Sorry, we can't seem to reach our servers! Please try again"
                            }
                        })
                    } else {
                        // updating a booking
                        url += "/" + this.booking.reference;
                        console.log(url);
                        body.reference = this.booking.reference;

                        this.$http.put(url, body
                        ).then(response => {
                            console.log("Booking updated:")
                            console.log(response);
                            this.waiting = false;
                            this.success = "Booking updated";
                            this.$root.$emit('booking-updated', response.data);
                            setTimeout(() => {
                                const element =  this.$el;
                                element.scrollTop = element.scrollHeight;
                            }, 100)
                        }).catch(error => {
                            this.waiting = false
                            if (error.response) {
                                this.error = error.response.data.message
                            } else {
                                this.error = "Sorry, we can't seem to reach our servers! Please try again"
                            }
                        })
                    }

                })
            }
        },
        mounted() {
            console.log("Mounting edit / add booking");
            this.checkInOut = [dayjs(this.booking.arrival).toDate(), dayjs(this.booking.departure).toDate()];
            if (this.booking && typeof this.booking.reference !== 'undefined') {
                this.copy.arrival = this.booking.arrival;
                this.copy.departure = this.booking.departure;
                this.copy.bookedBy = {};
                this.copy.bookedBy.firstName = this.booking.bookedBy.firstName;
                this.copy.bookedBy.lastName = this.booking.bookedBy.lastName;
                this.copy.bookedBy.email = this.booking.bookedBy.email;
                const numberOfNights = this.getNumberOfNights(this.getDatesArray());
                for (let room of this.booking.rooms) {
                    Vue.set(room, 'roomRateTotal', (room.roomRate * numberOfNights).toFixed(2));
                }
                this.copy.rooms = JSON.parse(JSON.stringify(this.booking.rooms));
            }
            this.providerChannels = store.currentEstablishmentProviderChannels;
            this.$refs.firstNameInput.focus();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/abstracts/variables";
    @import "../../styles/components/modal";
    @import "../../styles/layout/forms-account";
    @import "../../styles/layout/divisions";
    @import "../../styles/components/edit_task";
    @import "../../styles/components/edit_booking";
    @import "../../styles/components/question_answer";
</style>

<!--These are overrides for the flatpickr inputs -->
<style lang="scss">
    @import "../../styles/overrides/flatpickr";
</style>
